import { Meal } from "@/clients/models/Meal";
import { MealTime } from "@/clients/models/MealTime";
import { getPlanDayEntries, getPlanDayEntry } from "@/features/meal-plan/utils/plan-week-data";
import { useGetPlan } from "@/hooks/requests/plan/use-get-plan";
import { IonSkeletonText } from "@ionic/react";
import { addDays, format } from "date-fns";
import { useMemo } from "react";
import { MealPreviewCard } from "./meal-preview-card";
import { NoPlanCard } from "./no-plan-card";

interface PreviewMeal extends Meal {
  mealDay: string;
  mealTime: MealTime;
  mealIndex?: number;
}

export const PlanPreviewList = () => {
  const { plan, isLoading: isPlanLoading } = useGetPlan();

  const todaysMeals = useMemo(() => {
    const now = new Date();
    const nowDayOfWeek = format(now, "EEEE").toLowerCase();
    const planEntries = getPlanDayEntries(plan);
    const todayDateKey = format(now, "yyyy-MM-dd");
    const tomorrowDateKey = format(addDays(now, 1), "yyyy-MM-dd");
    const dayEntry =
      planEntries.find((entry) => entry.dateKey === todayDateKey) ??
      planEntries.find((entry) => entry.dateKey === tomorrowDateKey) ??
      getPlanDayEntry(plan, nowDayOfWeek);

    const dayMeals = dayEntry?.meals ?? [];
    const meals: PreviewMeal[] = [];
    const mealDay = dayEntry?.day;
    if (!mealDay || dayMeals.length === 0) {
      return [];
    }

    for (let i = 0; i < dayMeals.length; i++) {
      const mealTime = dayMeals[i].mealTime;
      for (let j = 0; j < dayMeals[i].data.length; j++) {
        if (mealTime === MealTime.SNACK) {
          meals.push({
            ...dayMeals[i].data[j],
            mealDay,
            mealTime,
            mealIndex: j,
          });
          continue;
        } else {
          meals.push({
            ...dayMeals[i].data[j],
            mealDay,
            mealTime,
            mealIndex: undefined,
          });
        }
      }
    }

    return meals;
  }, [plan]);

  if (isPlanLoading) {
    return <IonSkeletonText className="h-80 w-full" animated />;
  }
  if (todaysMeals.length === 0) {
    return <NoPlanCard />;
  }

  return (
    <div className="no-scrollbar flex gap-4 overflow-x-auto">
      {todaysMeals?.map((meal) => {
        const key = `${meal.id}-${meal.mealTime}-${meal.mealDay}`;
        return (
          <MealPreviewCard
            key={key}
            meal={meal}
            mealDay={meal.mealDay}
            mealTime={meal.mealTime}
            mealIndex={meal.mealIndex}
          />
        );
      })}
    </div>
  );
};
